import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const NovoModuloPopup: React.FC = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    const dismissed = localStorage.getItem(`popup_novo_modulo_v1.1_${user.id}`);
    if (!dismissed) {
      const timer = setTimeout(() => setIsOpen(true), 800);
      return () => clearTimeout(timer);
    }
  }, [user]);

  const handleClose = () => {
    setIsOpen(false);
    if (user) {
      localStorage.setItem(`popup_novo_modulo_v1.1_${user.id}`, 'dismissed');
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,.6)',
        backdropFilter: 'blur(4px)',
        padding: '28px',
        animation: 'fadeIn .25s ease',
      }}
      onClick={handleClose}
    >
      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes popupIn { from { opacity: 0; transform: scale(.96) } to { opacity: 1; transform: scale(1) } }
        @keyframes travel { 0% { left: -10% } 100% { left: 104% } }
      `}</style>

      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="heroTitle"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: '680px',
          maxHeight: '92vh',
          background: '#0E1930',
          border: '1px solid #233A5C',
          borderRadius: '20px',
          boxShadow: '0 40px 100px rgba(0,0,0,.6)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          animation: 'popupIn .3s ease',
        }}
      >
        {/* Close button */}
        <button
          aria-label="Fechar"
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '18px',
            right: '18px',
            zIndex: 5,
            width: '34px',
            height: '34px',
            borderRadius: '10px',
            border: '1px solid rgba(255,255,255,.12)',
            background: 'rgba(8,14,26,.5)',
            color: '#AEB9CB',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: '.15s ease',
          }}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        {/* Hero */}
        <div
          style={{
            position: 'relative',
            padding: '30px 34px 28px',
            background:
              'radial-gradient(600px 260px at 85% -30%, rgba(143,203,78,.14), transparent 60%), linear-gradient(160deg, #10203E 0%, #0A1730 100%)',
            overflow: 'hidden',
            borderBottom: '1px solid #233A5C',
          }}
        >
          {/* Brand mark */}
          <img
            src="/Falcon Hub 2.png"
            alt="Falcon Hub"
            style={{
              display: 'block',
              height: '34px',
              width: 'auto',
              marginBottom: '22px',
              filter: 'drop-shadow(0 2px 6px rgba(0,0,0,.4))',
            }}
          />

          {/* Ribbon */}
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '7px',
              background: 'linear-gradient(135deg, #E5AC40, #C88A26)',
              color: '#241701',
              fontSize: '11px',
              fontWeight: 800,
              letterSpacing: '.09em',
              padding: '5px 11px 5px 9px',
              borderRadius: '20px',
              marginBottom: '16px',
            }}
          >
            <svg viewBox="0 0 24 24" fill="none" width="12" height="12">
              <path
                d="M12 2l2.6 6.6L22 9l-5.4 4.6L18 21l-6-3.8L6 21l1.4-7.4L2 9l7.4-.4L12 2z"
                fill="#241701"
              />
            </svg>
            NOVO MÓDULO · AGENDAR VISITAS E GESTÃO DE VISITAS
          </div>

          <h1
            id="heroTitle"
            style={{
              margin: '0 0 10px',
              fontSize: 'clamp(24px, 4vw, 30px)',
              lineHeight: 1.15,
              fontWeight: 900,
              letterSpacing: '-.01em',
              color: '#F3F6FA',
            }}
          >
            Menos WhatsApp, menos planilha.
            <br />
            Mais visita <span style={{ color: '#8FCB4E', textShadow: '0 0 24px rgba(143,203,78,.35)' }}>confirmada</span>.
          </h1>

          <p
            style={{
              margin: 0,
              maxWidth: '480px',
              fontSize: '14px',
              lineHeight: 1.6,
              color: '#AEB9CB',
            }}
          >
            O novo módulo de Agendar Visitas e Gestão de Visitas coloca fornecedor, recepção e gestão na mesma agenda —
            do primeiro clique ao relatório final.
          </p>

          <span
            style={{
              display: 'inline-block',
              marginTop: '14px',
              fontSize: '11.5px',
              fontWeight: 700,
              letterSpacing: '.05em',
              color: '#7C8AA3',
              textTransform: 'uppercase',
            }}
          >
            2 perfis de acesso <strong style={{ color: '#8FCB4E' }}>·</strong> 5 etapas de fluxo{' '}
            <strong style={{ color: '#8FCB4E' }}>·</strong> selfie de identificação
          </span>
        </div>

        {/* Body */}
        <div
          style={{
            overflowY: 'auto',
            padding: '0 34px 8px',
          }}
        >
          {/* Section: Who gets what */}
          <div style={{ paddingTop: '28px' }}>
            <SectionLabel>Quem ganha o quê</SectionLabel>
            <p style={{ margin: '0 0 16px', fontSize: '12.5px', color: '#7C8AA3' }}>
              Cada lado da operação resolve uma dor diferente.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
              <AudienceCard
                icon={
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 21c0-4 3.6-7 8-7s8 3 8 7"
                      stroke="#8FCB4E"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                  </svg>
                }
                title="Fornecedores & visitantes"
                benefit="Mais autonomia, menos espera por resposta"
                items={[
                  'Agendam direto com o comprador certo',
                  'Escolhem data e horário na agenda semanal',
                  'Selfie de identificação no agendamento',
                  'Acompanham o status em tempo real',
                  'Recebem comprovante com código de verificação',
                  'Podem solicitar reagendamento',
                ]}
              />
              <AudienceCard
                icon={
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 21V8l9-5 9 5v13M9 21v-6h6v6"
                      stroke="#8FCB4E"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                }
                title="Recepção & gestão"
                benefit="Mais controle, zero surpresa na portaria"
                items={[
                  'Aprovam, reprovam ou cancelam solicitações',
                  'Fazem check-in com confirmação por selfie',
                  'Configuram horários por comprador',
                  'Bloqueiam dias específicos na agenda',
                  'Transferem visitas entre compradores',
                  'Controlam todo o fluxo de atendimento',
                ]}
              />
            </div>
          </div>

          {/* Section: Flow */}
          <div style={{ paddingTop: '28px' }}>
            <SectionLabel>Fluxo da visita</SectionLabel>
            <p style={{ margin: '0 0 16px', fontSize: '12.5px', color: '#7C8AA3' }}>
              Cada visita passa por 5 etapas rastreadas — sem planilha paralela.
            </p>
            <div
              style={{
                background: '#132445',
                border: '1px solid #233A5C',
                borderRadius: '14px',
                padding: '22px 18px 20px',
                overflowX: 'auto',
              }}
            >
              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  minWidth: '520px',
                  padding: '0 4px',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: '15px',
                    left: '22px',
                    right: '22px',
                    height: '2px',
                    background: '#233A5C',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      height: '100%',
                      width: '36px',
                      background: 'linear-gradient(90deg, transparent, #B3E672, transparent)',
                      animation: 'travel 3.2s linear infinite',
                    }}
                  />
                </div>
                {['Pendente', 'Aprovado', 'Chegou', 'Em atendimento', 'Finalizado'].map((label, i) => (
                  <div
                    key={label}
                    style={{
                      position: 'relative',
                      zIndex: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      width: '20%',
                      textAlign: 'center',
                    }}
                  >
                    <div
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        background: i < 4 ? 'rgba(143,203,78,.12)' : 'rgba(229,172,64,.12)',
                        border: `2px solid ${i < 4 ? '#8FCB4E' : '#E5AC40'}`,
                        color: i < 4 ? '#8FCB4E' : '#E5AC40',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '11px',
                        fontWeight: 800,
                        marginBottom: '10px',
                      }}
                    >
                      {i + 1}
                    </div>
                    <span style={{ fontSize: '11px', fontWeight: 700, color: '#AEB9CB', lineHeight: 1.3 }}>
                      {label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Section: Pós-visita */}
          <div style={{ paddingTop: '28px' }}>
            <SectionLabel>Pós-visita</SectionLabel>
            <p style={{ margin: '0 0 16px', fontSize: '12.5px', color: '#7C8AA3' }}>
              A opinião de quem visitou vira dado, automaticamente.
            </p>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                background: '#132445',
                border: '1px solid #233A5C',
                borderRadius: '14px',
                padding: '16px 18px',
              }}
            >
              <div
                style={{
                  flex: '0 0 auto',
                  width: '38px',
                  height: '38px',
                  borderRadius: '10px',
                  background: 'rgba(229,172,64,.12)',
                  border: '1px solid rgba(229,172,64,.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <svg viewBox="0 0 24 24" fill="none" width="19" height="19">
                  <path
                    d="M12 17l-5.5 3 1.4-6.1L3 9.6l6.2-.5L12 3.4l2.8 5.7 6.2.5-4.9 4.3 1.4 6.1z"
                    stroke="#E5AC40"
                    strokeWidth="1.6"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <p style={{ fontSize: '13px', color: '#AEB9CB', lineHeight: 1.5, margin: 0 }}>
                <strong style={{ color: '#F3F6FA' }}>Avaliação automática</strong> por estrelas, sim/não e texto
                livre — com perguntas personalizáveis por tipo de visita.
              </p>
            </div>
          </div>

          {/* Section: Indicators */}
          <div style={{ paddingTop: '28px', paddingBottom: '8px' }}>
            <SectionLabel>Indicadores e relatórios</SectionLabel>
            <p style={{ margin: '0 0 16px', fontSize: '12.5px', color: '#7C8AA3' }}>
              O que antes era achismo, agora é dashboard.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
              <Metric
                icon={
                  <path
                    d="M3 3v18h18M7 15l4-4 3 3 5-6"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                }
                text="Comparecimento, faltas e pontualidade"
              />
              <Metric
                icon={
                  <>
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
                    <path
                      d="M12 7v5l3.5 2"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                  </>
                }
                text="Tempo médio de atendimento e permanência"
              />
              <Metric
                icon={
                  <path
                    d="M8 21V11M14 21V3M20 21v-7M2 21h20"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                }
                text="Ranking de compradores e fornecedores"
              />
              <Metric
                icon={
                  <>
                    <rect
                      x="3"
                      y="4"
                      width="18"
                      height="17"
                      rx="2"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <path d="M3 9h18" stroke="currentColor" strokeWidth="1.8" />
                  </>
                }
                text="Taxa de ocupação da agenda"
              />
              <Metric
                icon={
                  <path
                    d="M4 19l5-8 4 4 7-11"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                }
                text="Evolução diária de agendamentos"
              />
              <Metric
                icon={
                  <path
                    d="M12 2L4 6v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10V6l-8-4z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                }
                text="Dashboard geral em tempo real"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: '20px 34px 26px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '14px',
            borderTop: '1px solid #233A5C',
            background: '#0E1930',
          }}
        >
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              fontFamily: 'inherit',
              fontSize: '13px',
              fontWeight: 600,
              color: '#7C8AA3',
              cursor: 'pointer',
              padding: '8px 4px',
              transition: '.15s ease',
            }}
          >
            Ver depois
          </button>
          <button
            onClick={handleClose}
            style={{
              fontFamily: 'inherit',
              fontSize: '14px',
              fontWeight: 800,
              letterSpacing: '.01em',
              padding: '12px 22px',
              borderRadius: '11px',
              cursor: 'pointer',
              border: 'none',
              background: 'linear-gradient(135deg, #8FCB4E, #6FA637)',
              color: '#0C1704',
              boxShadow: '0 10px 24px rgba(143,203,78,.32)',
              transition: '.15s ease',
            }}
          >
            Explorar o módulo agora
          </button>
        </div>
      </div>
    </div>
  );
};

// Sub-components
const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontSize: '11px',
      fontWeight: 800,
      letterSpacing: '.14em',
      textTransform: 'uppercase',
      color: '#E5AC40',
      margin: '0 0 4px',
    }}
  >
    {children}
    <span style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, #233A5C, transparent)' }} />
  </div>
);

const AudienceCard: React.FC<{
  icon: React.ReactNode;
  title: string;
  benefit: string;
  items: string[];
}> = ({ icon, title, benefit, items }) => (
  <div
    style={{
      background: '#132445',
      border: '1px solid #233A5C',
      borderRadius: '14px',
      padding: '18px 18px 16px',
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
      <div
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '9px',
          background: 'rgba(143,203,78,.12)',
          border: '1px solid rgba(143,203,78,.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: '0 0 auto',
        }}
      >
        <div style={{ width: '16px', height: '16px' }}>{icon}</div>
      </div>
      <h3 style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: '#F3F6FA' }}>{title}</h3>
    </div>
    <p style={{ margin: '0 0 12px', fontSize: '12px', color: '#8FCB4E', fontWeight: 600 }}>{benefit}</p>
    <ul
      style={{
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '9px',
      }}
    >
      {items.map((item) => (
        <li
          key={item}
          style={{
            fontSize: '13px',
            lineHeight: 1.5,
            color: '#AEB9CB',
            paddingLeft: '15px',
            position: 'relative',
          }}
        >
          <span
            style={{
              position: 'absolute',
              left: 0,
              top: '6.5px',
              width: '5px',
              height: '5px',
              borderRadius: '50%',
              background: '#8FCB4E',
            }}
          />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const Metric: React.FC<{ icon: React.ReactNode; text: string }> = ({ icon, text }) => (
  <div
    style={{
      background: '#132445',
      border: '1px solid #233A5C',
      borderRadius: '14px',
      padding: '14px 14px 13px',
    }}
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      style={{ width: '16px', height: '16px', color: '#8FCB4E', marginBottom: '9px' }}
    >
      {icon}
    </svg>
    <p style={{ margin: 0, fontSize: '12px', lineHeight: 1.45, color: '#AEB9CB', fontWeight: 600 }}>{text}</p>
  </div>
);

export default NovoModuloPopup;
